import React from 'react';
import {
    setInvoiceProperty,
    // stornoInvoiceByIdAndWithReclamationNote,
    // fiscalizeConcludedInvoice,
    // loadInvoicePreview,
    // getIssuedStornoInvoice,
    editConcludedInvoice,
    handlePadding,
    setStornoPreview,
} from './controler';
import { CurrencySelection, SelectLocale } from '../checkout/CheckoutOptions';
import InlineModal from '@components/modalInline';
import ConfirmButtons from '@components/buttons/confirmButtons';
import { openInNewTab } from '../checkout/controler';
// import PermissionCheck from '@components/PermissionCheck';
import {
    FiscalGeneralSettings,
    InvoiceModelWithInvoiceItems,
    // InvoiceType,
    GeneralSettingModel,
    ReservationModelWithModelsIncluded,
    AdvancePaymentsInterface,
} from '@common/modelDefinition';
import { getGeneralSettingsByPrefix, getVirtualStornoInvoice } from '../checkout/api';
import { printInvoice } from './api';
// import translate from '@data/translations';
import useStore from '@data/state/zustand';
import { InvoiceTypeEnum } from '../checkout/interfaces';
import translate from '@data/translations';

// ============================================
// STYLES
// ============================================
const toolbarStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        padding: '10px 16px',
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e5e7eb',
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap' as const,
    },
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    rightGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    optionsGroup: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        backgroundColor: '#f3f4f6',
        borderRadius: '6px',
        padding: '2px',
    },
    buttonGroup: {
        display: 'inline-flex',
        backgroundColor: '#f3f4f6',
        borderRadius: '6px',
        padding: '2px',
    },
    section: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    divider: {
        width: '1px',
        height: '24px',
        backgroundColor: '#e5e7eb',
        margin: '0 8px',
    },
    spacer: {
        flex: 1,
    },
    optionToggle: (isActive: boolean) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '5px 10px',
        fontSize: '12px',
        fontWeight: 500,
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        backgroundColor: isActive ? '#ffffff' : 'transparent',
        color: isActive ? '#1d4ed8' : '#6b7280',
        boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
    }),
    toggleIndicator: (isActive: boolean) => ({
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: isActive ? '#3b82f6' : '#9ca3af',
        transition: 'all 0.15s ease',
    }),
    primaryButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '6px 12px',
        fontSize: '13px',
        fontWeight: 500,
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        backgroundColor: '#3b82f6',
        color: '#ffffff',
    },
    secondaryButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '6px 12px',
        fontSize: '13px',
        fontWeight: 500,
        border: '1px solid #e5e7eb',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        backgroundColor: '#ffffff',
        color: '#374151',
    },
    linkButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '6px 10px',
        fontSize: '12px',
        fontWeight: 500,
        border: '1px solid #bfdbfe',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        backgroundColor: '#eff6ff',
        color: '#2563eb',
    },
    paddingControl: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '6px 8px',
        fontSize: '12px',
        fontWeight: 500,
        border: '1px solid #e5e7eb',
        borderRadius: '6px',
        cursor: 'pointer',
        backgroundColor: '#ffffff',
        color: '#6b7280',
    },
};

// ============================================
// ICONS
// ============================================
const PrintIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
    </svg>
);

const SpacingIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 3v18M3 12h18M8 8l4-4 4 4M8 16l4 4 4-4" />
    </svg>
);

const LinkIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
    </svg>
);

const NoteIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </svg>
);

// ============================================
// INTERFACES
// ============================================
interface PrintViewToolbarProps {
    invoice: InvoiceModelWithInvoiceItems;
    location: any;
    setShowGuestNumber: Function;
    showGuestsNumber: boolean;
    setShowRooms: Function;
    showRooms: boolean;
    history: any;
    translate: any;
    groupReservationsArray?: ReservationModelWithModelsIncluded[];
    invoiceRefId?: number;
}

// ============================================
// MAIN COMPONENT
// ============================================
const PrintViewToolbar = (props: PrintViewToolbarProps) => {
    const { invoice, location, setShowGuestNumber, showGuestsNumber, setShowRooms, showRooms, translate, groupReservationsArray, invoiceRefId } =
        props;

    const systemLocale: string = useStore((appState: any) => appState.locale);
    const fiscalGeneralSettings: FiscalGeneralSettings = useStore(
        (appState: any) => appState.fiscal.fiscalGeneralSettings
    );
    const refInvoice: InvoiceModelWithInvoiceItems = useStore(
        (appState: any) => appState.state.invoicePresenter.refInvoice
    );
    const padding: number = useStore((appState: any) => appState.state.invoicePresenter.padding);

    //Fiscal
    const { country } = fiscalGeneralSettings ? fiscalGeneralSettings : { country: '' };

    const advancePayments = invoice.advancePayments
        ? typeof invoice.advancePayments === 'string'
            ? JSON.parse(invoice.advancePayments)
            : invoice.advancePayments
        : [];

    return (
        <div className="d-print-none" style={toolbarStyles.container}>
            {/* Row 1: Currency, Language, Options */}
            <div style={toolbarStyles.row}>
                <div style={toolbarStyles.leftGroup}>
                    <CurrencySelection
                        setCurrencyViaPropsAction={setInvoiceProperty}
                        invoice={invoice}
                        location={location}
                    />

                    <div style={toolbarStyles.divider} />

                    <SelectLocale
                        setLocaleViaPropsAction={setInvoiceProperty}
                        invoice={invoice}
                        systemLocale={systemLocale}
                        location={location}
                    />
                </div>

                {/* Options: Guests + Simple View grouped together - right side */}
                <div style={toolbarStyles.optionsGroup}>
                    {invoice.reservationId || (groupReservationsArray && groupReservationsArray.length > 0) ? (
                        <ShowGuestsNumber
                            setShowGuestNumber={setShowGuestNumber}
                            showGuestsNumber={showGuestsNumber}
                            translate={translate}
                        />
                    ) : null}
                    {invoice.reservationId || (groupReservationsArray && groupReservationsArray.length > 0) ? (
                        <ShowRoomsToggle
                            setShowRooms={setShowRooms}
                            showRooms={showRooms}
                            translate={translate}
                        />
                    ) : null}
                    <SimpleViewTogglePrint translate={translate} invoice={invoice} />
                </div>
            </div>

            {/* Row 2: Note left, Actions right */}
            <div style={toolbarStyles.row}>
                <div style={toolbarStyles.leftGroup}>
                    {advancePayments.length > 0 && invoiceRefId
                        ? advancePayments.map((ap: AdvancePaymentsInterface) => {
                              return (
                                  <VirtualAdvanceInvoicesStorno
                                      key={ap.id}
                                      advanceInvoiceId={ap.id}
                                      country={country}
                                      invoiceRefId={invoiceRefId}
                                      invoiceId={invoice.id}
                                  />
                              );
                          })
                        : null}
                    <RelatedInvoice
                        refInvoice={refInvoice}
                        country={country}
                        invoiceRefId={invoiceRefId}
                        invoiceId={invoice.id}
                        invoiceType={invoice.invoiceType}
                    />
                    <EditInvoice invoice={invoice} translate={translate} />
                </div>

                <div style={toolbarStyles.rightGroup}>
                    <button
                        style={toolbarStyles.primaryButton}
                        onClick={() => {
                            window.print();
                        }}
                    >
                        <PrintIcon /> A4
                    </button>
                    
                    <button
                        style={toolbarStyles.secondaryButton}
                        onClick={async () => {
                            await printInvoice(invoice, country);
                        }}
                    >
                        <PrintIcon /> POS
                    </button>
                    
                    <button
                        style={toolbarStyles.paddingControl}
                        onClick={() => {
                            handlePadding();
                        }}
                        title={translate('Adjust spacing')}
                    >
                        <SpacingIcon /> {padding}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ============================================
// SUB-COMPONENTS (with original logic, styled)
// ============================================

interface RelatedInvoiceProps {
    refInvoice: InvoiceModelWithInvoiceItems;
    country: string;
    invoiceId?: number;
    invoiceType?: number;
    invoiceRefId?: number;
}

const RelatedInvoice = (props: RelatedInvoiceProps) => {
    const { refInvoice, country, invoiceId, invoiceType, invoiceRefId } = props;

    if (!refInvoice) {
        if (country === 'BIH-RS' && invoiceType === InvoiceTypeEnum.advance) {
            return (
                <button
                    style={toolbarStyles.linkButton}
                    onClick={async () => {
                        if (invoiceRefId) {
                            if (invoiceId) {
                                const { invoice, refInvoice } = await getVirtualStornoInvoice(invoiceRefId);
                                if (invoice) {
                                    setStornoPreview(invoice, refInvoice);
                                }
                            } else {
                                if (process.env.NODE_ENV === 'development') {
                                    openInNewTab(`http://localhost:5555/#/invoiceView/${invoiceRefId}`);
                                } else {
                                    openInNewTab(window.location.origin + `/#/invoiceView/${invoiceRefId}`);
                                }
                            }
                        }
                    }}
                >
                    <LinkIcon />
                    {invoiceId ? translate('Advance Ref.') : translate('Advance')}
                </button>
            );
        } else {
            return null;
        }
    }

    return (
        <button
            style={toolbarStyles.linkButton}
            onClick={() => {
                if (process.env.NODE_ENV === 'development') {
                    openInNewTab(`http://localhost:5555/#/invoiceView/${refInvoice.id}`);
                } else {
                    openInNewTab(window.location.origin + `/#/invoiceView/${refInvoice.id}`);
                }
            }}
        >
            <LinkIcon />
            {refInvoice.invoiceNumberFull}
        </button>
    );
};

interface ShowGuestsNumberProps {
    setShowGuestNumber: Function;
    showGuestsNumber: boolean;
    translate: any;
}

const ShowGuestsNumber = (props: ShowGuestsNumberProps) => {
    const { setShowGuestNumber, showGuestsNumber, translate } = props;
    return (
        <button
            style={toolbarStyles.optionToggle(showGuestsNumber)}
            onClick={() => {
                setShowGuestNumber(!showGuestsNumber);
            }}
        >
            <span style={toolbarStyles.toggleIndicator(showGuestsNumber)} />
            {translate('Print number of guests')}
        </button>
    );
};

interface ShowRoomsToggleProps {
    setShowRooms: Function;
    showRooms: boolean;
    translate: any;
}

const ShowRoomsToggle = (props: ShowRoomsToggleProps) => {
    const { setShowRooms, showRooms, translate } = props;
    return (
        <button
            style={toolbarStyles.optionToggle(showRooms)}
            onClick={() => {
                setShowRooms(!showRooms);
            }}
        >
            <span style={toolbarStyles.toggleIndicator(showRooms)} />
            {translate('Print rooms')}
        </button>
    );
};

interface EditInvoiceProps {
    invoice: InvoiceModelWithInvoiceItems;
    translate: any;
}

const EditInvoice = (props: EditInvoiceProps) => {
    const { invoice, translate } = props;
    const [modalVisible, setModalVisible] = React.useState<boolean>(false);

    return (
        <React.Fragment>
            {modalVisible ? (
                <InlineModal show={modalVisible} header={translate('Edit note')} setShow={setModalVisible} width="lg">
                    <InlineModalEditContent invoice={invoice} setModalVisible={setModalVisible} translate={translate} />
                </InlineModal>
            ) : null}

            <button
                style={toolbarStyles.secondaryButton}
                onClick={() => {
                    setModalVisible(true);
                }}
            >
                <NoteIcon />
                {translate('Note')}
            </button>
        </React.Fragment>
    );
};

interface InlineModalEditContentProps {
    invoice: InvoiceModelWithInvoiceItems;
    setModalVisible: Function;
    translate: any;
}

const InlineModalEditContent = (props: InlineModalEditContentProps) => {
    const { invoice, setModalVisible, translate } = props;
    const { note = '' } = invoice;

    const [localNote, setLocalNote] = React.useState<string>('');
    const [genericNotes, setGenericNotes] = React.useState([]);
    const [selectedNote, setSelectedNote] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (note) {
            setLocalNote(note); //kada dobijem osvježenu porku iz propsa, ažuriram i lokalno stanje
        } else {
            setLocalNote('');
        }
    }, [note]);

    React.useEffect(() => {
        const loadData = async () => {
            const _genericNotes = await getGeneralSettingsByPrefix();
            setGenericNotes(_genericNotes);
        };
        loadData().catch((err) => {
            console.log(err);
        });
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-center mb-4p mt-4p ">
                <textarea
                    onChange={(e) => {
                        setLocalNote(e.target.value);
                    }}
                    // onBlur={() => setReclamationReason(localReclamationReason)}
                    value={localNote}
                    className="form-control"
                    placeholder={translate('Note')}
                    rows={6}
                ></textarea>
            </div>
            <hr />

            <div className="row justify-content-center align-items-center mb-4p mt-4p">
                <label className="col-4 col-form-label">
                    <small>{translate('Predefined notes')}</small>
                </label>
                <div className="col-8">
                    <select
                        name="selectNote"
                        className="form-control"
                        value={selectedNote ? selectedNote : ''}
                        onChange={async (e) => {
                            if (e.target.value) {
                                setSelectedNote(e.target.value);
                                const targetNote: GeneralSettingModel | undefined = genericNotes.find(
                                    (g: GeneralSettingModel) => g.key === e.target.value
                                );
                                if (targetNote) {
                                    const { params } = targetNote;
                                    if (params) {
                                        const _note = localNote.length > 0 ? `${localNote}\n${params}` : params;
                                        setLocalNote(_note);
                                    }
                                }
                            }
                        }}
                    >
                        <React.Fragment>
                            <option value={'noReason'} key={'noReason'}>
                                {translate('Nothing selected')}
                            </option>
                            {genericNotes.map((g: any) => {
                                return (
                                    <option value={g.key} key={g.uuid}>
                                        {g.key.split('_').map((text: string, index: number) => {
                                            if (index === 1) {
                                                return text;
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </option>
                                );
                            })}
                        </React.Fragment>
                    </select>
                </div>
            </div>
            <hr />
            <div className="text-center">
                <ConfirmButtons
                    onConfirm={async () => {
                        const newInvoice = { ...invoice };
                        newInvoice.note = localNote;
                        newInvoice.isSyncedWithMaster = false;
                        await editConcludedInvoice(newInvoice);
                        // await setNoteToConcludedInvoice(newInvoice); offlinePOS merge - provjeriti
                        window.location.reload();
                        setModalVisible(false);
                    }}
                    onCancel={() => {
                        setModalVisible(false);
                    }}
                />
            </div>
        </div>
    );
};

interface VirtualAdvanceInvoicesStornoProps {
    invoiceId?: number;
    country: string;
    advanceInvoiceId: number;
    invoiceRefId: number;
}

const VirtualAdvanceInvoicesStorno = (props: VirtualAdvanceInvoicesStornoProps) => {
    const { invoiceId, country, advanceInvoiceId, invoiceRefId } = props;
    if (country === 'BIH-RS') {
        return (
            <button
                style={toolbarStyles.linkButton}
                onClick={async () => {
                    if (invoiceId) {
                        const { invoice, refInvoice } = await getVirtualStornoInvoice(advanceInvoiceId);
                        if (invoice) {
                            setStornoPreview(invoice, refInvoice);
                        }
                    } else {
                        if (process.env.NODE_ENV === 'development') {
                            openInNewTab(`http://localhost:5555/#/invoiceView/${invoiceRefId}`);
                        } else {
                            openInNewTab(window.location.origin + `/#/invoiceView/${invoiceRefId}`);
                        }
                    }
                }}
            >
                <LinkIcon />
                {invoiceId ? translate('Advance Ref.') : translate('Advance')}
            </button>
        );
    } else {
        return null;
    }
};

interface SimpleViewTogglePrintProps {
    translate: any;
    invoice: InvoiceModelWithInvoiceItems;
}

const SimpleViewTogglePrint = (props: SimpleViewTogglePrintProps) => {
    const { translate, invoice } = props;
    const simpleViewToggle = useStore((appState: any) => appState.state.invoicePresenter.simpleViewEnabled);

    // Ako toggle nije postavljen (null/undefined), koristi invoice.simpleView kao default
    const simpleViewEnabled =
        simpleViewToggle !== null && simpleViewToggle !== undefined
            ? simpleViewToggle
            : invoice.simpleView || false;
    const isValidInvoiceType = invoice.invoiceType !== InvoiceTypeEnum.advance;
    if (!isValidInvoiceType) {
        return null;
    }
    return (
        <button
            style={toolbarStyles.optionToggle(simpleViewEnabled)}
            onClick={() => {
                useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'simpleViewEnabled'], !simpleViewEnabled);
            }}
        >
            <span style={toolbarStyles.toggleIndicator(simpleViewEnabled)} />
            {translate('Simple view')}
        </button>
    );
};

export default PrintViewToolbar;